// Navigation helpers that work across routes (home anchors + route changes)

export const scrollToAnchor = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

// Navigate to a home-page anchor from any route
export const goToAnchor = (navigate, pathname, href) => {
  if (pathname !== "/") {
    navigate("/");
    setTimeout(() => scrollToAnchor(href), 450);
  } else {
    scrollToAnchor(href);
  }
};
